module.exports = __webpack_public_path__ + "img/users-gear-solid.d66ec08b.svg";